import { z } from "zod";

export const GrantApplicationType = [
  "Novel Applications",
  "Performance Optimization",
  "Developer Tools",
] as const;

export const GrantApplicationSchema = z.object({
  email: z.string().email(),
  name: z.string(),
  pitch: z.string(),
  type: z.enum(GrantApplicationType),
  githubRepo: z.string().optional(),
  videoDemo: z.string().optional(),
});

export type GrantApplication = z.infer<typeof GrantApplicationSchema>;
